import loadable from '@loadable/component';

import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const IdealistLogoOnDemand = hydrateOnDemand(
  loadable(() => import('./IdealistLogo'), {
    resolveComponent: (module) => module.IdealistLogo,
  }),
);
